// get all
export const FLAG_GETTING_LOCATIONS = 'FLAG_GETTING_LOCATIONS';
export const GET_LOCATIONS = 'GET_LOCATIONS';
export const CLEAR_LOCATIONS = 'CLEAR_LOCATIONS';
// get one
export const FLAG_LOCATION_ACTIVITY = 'FLAG_LOCATION_ACTIVITY';
export const GET_LOCATION = 'GET_LOCATION';
export const CLEAR_LOCATION = 'CLEAR_LOCATION';
